import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import Navbar from './../../components/Navbar';
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import IndustriesStickyMenu from './../../components/IndustriesStickyMenu';
import IndustriesImageContainer from './../../components/IndustriesImageContainer';
import Footer from './../../components/Footer';
import { PrimaryButton } from '../../components/StyledButtons';
import filter_color from "../../assets/images/design/colorFilter.svg"
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm';

const Healthcare = () => {
  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
  const modalDiscussionRef = useRef(null);
  const handleOverlayClick = (event) => {
    if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
      setModalDiscussionOpen(false)
    }
  };
  document.onkeydown = function (evt) {
    if (evt.code === 'Escape') {
      setModalDiscussionOpen(false)
    }
  };

  return (
    <div className='healthcare bg-primary'>
      <div className='color-filter-right' style={{ top: "30%" }}>
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <Navbar />
      <div className='container-fluid healthcare-header pb-100'>
        <div className='container'>

          {language === "en" ?
            <div className='col-sm-10 col-sm-offset-1 pt-150'>
              <div className='font-weight-bold text-center font-64 healthcare-header-title'>HEALTHCARE</div>
              <div className='col-sm-10 col-sm-offset-1'>
                <div className='underline-orange'></div>
              </div>
            </div>
            :
            <div className='col-sm-12 pt-150'>
              <div className='font-weight-bold text-center font-64 healthcare-header-title'>CHĂM SÓC SỨC KHỎE</div>
              <div className='col-sm-10 col-sm-offset-1'>
                <div className='underline-orange'></div>
              </div>
            </div>
          }
          <div className='col-sm-12 flex justify-center pt-50 px-0'>
            <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.industries')} currentPage={t('bread-crumbs.healthcare')} linkToPrevPage="/industries" />
          </div>
        </div>


      </div>
      <div className='healthcare-content container'>
        <div className='row flex-lg'>
          <div className='col-lg-w-400'>
            <IndustriesStickyMenu healthcareActive={true} />
          </div>
          <div className='col-lg-w--400 healthcare-content_info'>
            <p className='font-48 font-weight-medium text-white'>{t('healthcare.title')}</p>
            <p className='text-white pt-20'>{t('healthcare.content-1')}</p>
            <div className='pt-30'>
              <PrimaryButton
              onClick={() => setModalDiscussionOpen(true)}
              >{t('button.schedule-discussion')}</PrimaryButton>
            </div>
          </div>
        </div>
        <IndustriesImageContainer />
      </div>

      <Footer />

      {modalDiscussionOpen && <ModalContactDiscussionForm
        setOpenModal={setModalDiscussionOpen}
        handleOverlayClick={handleOverlayClick}
        modalRef={modalDiscussionRef} />}
    </div>
  )
}

export default Healthcare